export const HOME = {
  emergentLink: "emergent-link",
};

export const CALC = {
  // Header
  langToggle: "toggle-lang",
  appTitle: "app-title",

  // Load info inputs
  inputPickCity: "input-pick-city",
  inputDeliveryCity: "input-delivery-city",
  inputLoadedMiles: "input-loaded-miles",
  inputEmptyMiles: "input-empty-miles",
  inputPickupTime: "input-pickup-time",
  inputDeliveryTime: "input-delivery-time",
  inputWeight: "input-weight",
  inputCommodity: "input-commodity",
  inputRate: "input-rate",

  // Cost inputs
  inputCostPerMile: "input-cost-per-mile",
  inputDriverPay: "input-driver-pay-per-mile",
  inputDispatcherFee: "input-dispatcher-fee",
  inputMinProfit: "input-min-profit",

  // Actions
  btnSave: "btn-save-load",
  btnExport: "btn-export-pdf",
  btnReset: "btn-reset-defaults",
  btnClearHistory: "btn-clear-history",
  btnCompare: "btn-compare-selected",
  btnCloseCompare: "btn-close-compare",
  btnExportCompare: "btn-export-compare",

  // KPI cards
  kpiTotalMiles: "kpi-total-miles",
  kpiRealRpm: "kpi-real-rpm",
  kpiTripCost: "kpi-trip-cost",
  kpiDriverPay: "kpi-driver-pay",
  kpiDispatcherFee: "kpi-dispatcher-fee",
  kpiNetProfit: "kpi-net-profit",
  kpiProfitPerMile: "kpi-profit-per-mile",
  kpiTotalRate: "kpi-total-rate",

  // Decision
  decisionCard: "decision-card",
  decisionText: "decision-text",

  // History
  historyTable: "history-table",
  historyRow: "history-row",
  historyDelete: "history-delete",
  historyCheckbox: "history-checkbox",

  // Compare dialog
  compareDialog: "compare-dialog",
};
